module.exports = __webpack_public_path__ + "media/video_effect.55d2c67f.mp4";